import { useCallback } from 'react'
import { useToast as useToastContext, ToastType } from './ToastContext'

interface ToastOptions {
  title: string
  message?: string
  duration?: number
  action?: {
    label: string
    onClick: () => void
  }
}

export const useToast = () => {
  const { showToast } = useToastContext()

  const toast = useCallback((type: ToastType, options: ToastOptions | string) => {
    if (typeof options === 'string') {
      showToast({ type, title: options })
    } else {
      showToast({ type, ...options })
    }
  }, [showToast])

  return {
    toast,
    success: (options: ToastOptions | string) => toast('success', options),
    error: (options: ToastOptions | string) => toast('error', options),
    warning: (options: ToastOptions | string) => toast('warning', options),
    info: (options: ToastOptions | string) => toast('info', options),
  }
}